<template>
<article class="definition-item">
  <div class="definition-title">{{ title }}</div>
  <div class="definition-definition">
    <slot></slot>
  </div>
</article>
</template>

<script>
export default {
  props: ['title'],
}
</script>

<style lang="less">
.definition-item {
  @apply py-4 w-full border-b border-grey-light border-solid;

  .definition-title {
    @apply text-3xl font-light mb-2;
  }

  .definition-definition {
    p {
      @apply mb-4 leading-normal;

      &:last-child {
        @apply mb-0;
      }
    }
  }

  &:last-child {
    @apply border-0;

    .definition-definition {
      @apply border-0 pb-0;
    }
  }
}

@screen lg {
  .definition-item {
    @apply flex pt-8 border-0 pb-0 px-0;

    .definition-title {
      @apply pr-4 w-1/3;
    }

    .definition-definition {
      @apply w-2/3 border-b border-grey-light border-solid pb-8 px-0;
    }
  }
}
</style>
